/*
 * @Author: your name
 * @Date: 2020-06-29 10:47:30
 * @LastEditTime: 2020-06-29 11:30:52
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \Parts_APP\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    // set './app.js' => 'app'
    let moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
    const value = modulesFiles(modulePath)
    const patterm = /\//
    if (patterm.test(moduleName)) {
        moduleName = moduleName.split('/')[1]
    }
    modules[moduleName] = value.default
    return modules
}, {})

const store = new Vuex.Store({
    modules,
    getters
})
console.log(store, '12121')
export default store
